export default __webpack_public_path__ + "static/media/hht2_Intonation_15.75522eca.png";